import { LanguageSelector } from "./language-selector";

export default LanguageSelector;